/* eslint-disable react/no-danger */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import IconX from '../Icons/IconX';
import { StorageHelper } from '../utils/StorageHelper';
import { MisDatosConstants } from '../utils/MisDatosConstants';

interface Props {
  title: string;
  textHTMLContent: string;
  textCentered: boolean;
  acceptButtonTextKey: string;
  cancelButtonTextKey?: string;
  showModal: boolean;
  isBig: boolean;
  isOro?: boolean;
  isSmall: boolean;
  setShowModal: (visible: boolean) => void;
  doAceptar: () => void;
  doClose: () => void;
  showCancel: boolean;
  hideXButton?: boolean;
  pie?: string;
  setErrorType?: (errorType: number) => void;
  activarDoClose?: boolean;
  activarDoCloseCif?: boolean;
}

const ModalConfirmacion: FC<Props> = (props) => {
  const { t } = useTranslation();
  const {
    doAceptar,
    doClose,
    title,
    textHTMLContent,
    textCentered,
    showModal,
    setShowModal,
    isBig,
    cancelButtonTextKey,
    isOro,
    isSmall,
    showCancel,
    acceptButtonTextKey,
    hideXButton,
    pie,
    setErrorType,
    activarDoCloseCif = false,
  } = props;

  const hideModal = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    setShowModal(false);
    if (setErrorType) {
      setErrorType(0);
    }
    // const element = document.querySelector(
    //   '#modal-confirmacion1',
    // ) as HTMLElement;
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    // element.parentNode.removeChild(element);
  };

  //* *** Save with Enter key
  const saveInfo = (e) => {
    if (e.key === 'Enter' && e.keyCode === 13) {
      hideModal(e);
      doAceptar();
      window.removeEventListener('keydown', saveInfo, false);
    }
  };

  const desactivarModal = () => {
    const isOpenV2P = StorageHelper.getCambioTelefCom();
    if (isOpenV2P) {
      const elements = document.querySelectorAll('#modal-sms.is-active')
        ? document.querySelectorAll('#modal-sms.is-active')
        : null;
      if (elements != null && elements.length > 1) {
        elements[1].classList.remove('is-active');
      }
    }
    const whoAskedChange = sessionStorage.getItem(
      MisDatosConstants?.WHO_ASKED_CHANGED,
    );
    if (isOpenV2P && whoAskedChange !== null) {
      const element = document.querySelector('#modal-confirmacion1.is-active');
      if (element != null) {
        element.classList.remove('is-active');
      }
    }
  };

  useEffect(() => {
    const element = document.querySelector(
      '#modal-confirmacion1.is-active',
    ) as HTMLElement;

    if (showModal && element) {
      window.addEventListener('keydown', saveInfo, false);
      window.focus();
    }
    desactivarModal();
    return () => {
      window.removeEventListener('keydown', saveInfo, false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModal]);
  return (
    <div
      className={`modal ${
        isBig ? 'modal--large' : isSmall ? 'modal--small' : 'modal'
      } ${showModal ? 'is-active' : ''}`}
      id="modal-confirmacion1"
    >
      <div className="modal__background" />
      <div className="modal__card u-text-center">
        <header className="modal__card-head u-flex">
          <div
            className={
              isOro
                ? 'modal__card-title-oro'
                : activarDoCloseCif
                ? 'modal__card-title-cif'
                : 'modal__card-title'
            }
          >
            {title}
          </div>
          {(() => {
            if (
              hideXButton === null ||
              hideXButton === undefined ||
              !hideXButton
            ) {
              return (
                <a
                  className="modal__card-close modal-cerrar"
                  onClick={(e: any) => {
                    hideModal(e);
                    doClose();
                  }}
                >
                  <span className="hidden">Icono para cerrar modal</span>
                  <div className="icon icon-medium icon--close">
                    <IconX classCss="" />
                  </div>
                </a>
              );
            }
            return false;
          })()}
        </header>
        <div className="modal__card-body">
          <fieldset>
            <div className="form-group select-wrapper u-margin-bottom">
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label className="control-label u-text-left u-full-width u-margin-bottom">
                <p
                  className={textCentered ? 'u-text-center' : ''}
                  dangerouslySetInnerHTML={{
                    __html: textHTMLContent,
                  }}
                />
              </label>
              <div className="modal__botonera">
                {(() => {
                  if (showCancel) {
                    return (
                      <>
                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                        <a
                          className={
                            isOro
                              ? 'btn btn-secundary btn-secundary__oro u-margin-bottom-small'
                              : 'btn btn-secundary u-margin-bottom-small'
                          }
                          onClick={(e: any) => {
                            hideModal(e);
                            doClose();
                          }}
                        >
                          {cancelButtonTextKey
                            ? t(cancelButtonTextKey)
                            : t('datos.accessdata.cancelar')}
                        </a>
                      </>
                    );
                  }
                  return false;
                })()}
                <button
                  id="confirm-email-btn"
                  type="submit"
                  onClick={(e: any) => {
                    doAceptar();
                    hideModal(e);
                  }}
                  className={isOro ? 'btn btn-oro' : 'btn btn-primary'}
                >
                  {t(acceptButtonTextKey)}
                </button>
                {(() => {
                  if (activarDoCloseCif) {
                    return (
                      <>
                        <a
                          className="btn-cif btn-secundary u-margin-bottom-small"
                          onClick={(e: any) => {
                            hideModal(e);
                            doClose();
                          }}
                        >
                          {cancelButtonTextKey
                            ? t(cancelButtonTextKey)
                            : t('datos.accessdata.cancelar')}
                        </a>
                      </>
                    );
                  }
                  return false;
                })()}
              </div>
            </div>
          </fieldset>
          {(() => {
            const mostrarPie = !!pie;
            if (mostrarPie) {
              return (
                <>
                  {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                  <footer className="u-font-italic u-font-tiny u-margin-top-medium u-margin-bottom-small">
                    {pie}
                  </footer>
                </>
              );
            }
            return '';
          })()}
        </div>
      </div>
    </div>
  );
};

export default ModalConfirmacion;
